var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiMobile3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 4.99935V7.01601C18.3333 8.33268 17.4999 9.16602 16.1833 9.16602H13.3333V3.34101C13.3333 2.41601 14.0916 1.66602 15.0166 1.66602C15.9249 1.67435 16.7583 2.04101 17.3583 2.64101C17.9583 3.24935 18.3333 4.08268 18.3333 4.99935Z",
    stroke: "#6C757D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 5.83268V17.4993C1.66675 18.191 2.45008 18.5827 3.00008 18.166L4.42508 17.0993C4.75841 16.8493 5.22508 16.8827 5.52508 17.1827L6.90841 18.5744C7.23341 18.8994 7.76675 18.8994 8.09175 18.5744L9.49175 17.1744C9.78341 16.8827 10.2501 16.8493 10.5751 17.0993L12.0001 18.166C12.5501 18.5744 13.3334 18.1827 13.3334 17.4993V3.33268C13.3334 2.41602 14.0834 1.66602 15.0001 1.66602H5.83341H5.00008C2.50008 1.66602 1.66675 3.15768 1.66675 4.99935V5.83268Z",
    stroke: "#6C757D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.8418H10",
    stroke: "#6C757D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.50781H10",
    stroke: "#6C757D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99634 10.834H5.00382",
    stroke: "#6C757D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99634 7.5H5.00382",
    stroke: "#6C757D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiMobile3);
export default __webpack_public_path__ + "static/media/DI-mobile3.22dc64f8f6120270b6a69a4771a946bd.svg";
export { ForwardRef as ReactComponent };